<template>
  <div class="content companycontent">
    <div class="companyInfo">
      <div class="showTree ">
        <el-tree :data="data" :props="defaultProps" node-key="id" @node-click="handleNodeClick" :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span :class="rootActive == node.key?'treeSelect':''">{{ node.label }}</span>
          </span>
        </el-tree>
      </div>

      <div class="treeDetail">
        <div class="companyIcon">
          <i class="lt"></i>
          <i class="rt"></i>
          <div class="ptabs">
            <i class="iconfont iconcheck"></i>
            <i class="border"></i> 人员管理
          </div>
          <div class="btns" v-show="showForm">
            <button class="GreenSmBtn" @click="$refs.userDialog.addnew()">添加人员</button>
          <downloadBtn :url="'operation/empApi/export/exportEmpListByDepId/' + tabId" :params="{}" method="post"></downloadBtn>
          </div>
        </div>
        <el-table :data="tableData" class="stripeTable" height="calc(100% - 75px)" v-show="showForm" >
          <el-table-column show-overflow-tooltip v-for="(item,index) in tableLable" :key='index' :prop="item.prop" :label="item.label" align="center">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-link icon="iconfont iconedit" type="text" size="small" @click="$refs.userDialog.edit(scope.$index, scope.row)">编辑</el-link>
              <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="showMore" v-show="!showForm" style="text-align: center;display: flex;align-items: center;justify-content: center;color: #b5b5b5">请点击左侧菜单！</div>

      </div>
      <!-- treeDetail -->
    </div>
    <!-- </el-tab-pane>
    </el-tabs> -->
    <add-dialog ref="userDialog" :groupArr='groupArr' :branchArr='data'></add-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      tabName: "jsgl",
      data: [],
      showForm: false,
      defaultProps: {
        children: "areas",
        label: "name",
      },
      other: { companyId: localStorage.getItem("companyId") },
      defaultProps: {
        children: "children",
        label: "name",
      },
      rootActive: 0,
      tableLable: [
        {
          prop: "name",
          label: "人员",
        },
        {
          prop: "deptNames",
          label: "部门",
        },
        {
          prop: "groupNames",
          label: "功能分组",
        },
        {
          prop: "userAccount",
          label: "账号",
        },
      ],
      tableData: [],
      detailData: {},
      groupArr: [],
      tabId:''
    };
  },
  computed: {},
  components: {
    normalNav: () => import("public/normalNav"),
    addDialog: () => import("./addDialog"),
    easyTable: () => import("public/easyTable"),
    downloadBtn:() => import('public/download')
  },
  methods: {
    getInfo(data) {
      this.$axiosget("operation/empApi/getEmpListByDepId/" + data).then(res => {
        this.tableData = res.data.data;
      });
    },
    getTree() {
      this.$axiosget("operation/deptApi/getDeptList").then(res => {
        this.data = res.data.data;
      });
    },
    getGroup(data) {
      this.$axiosget("operation/deptApi/getDeptGroupsByDeptId/" + data).then(
        res => {
          this.groupArr = res.data.data;
        }
      );
    },
    filterNode(value, data, node) {
      return value.some(id => id == data.id);
    },
    handleNodeClick(data, node, self = {}) {
      //console.log(data,"click")
      if (!data.id) {
        this.showForm = false;
        return;
      }
      var that = this;
      that.loading = false;
      this.showForm = true;
      this.rootActive = data.id;
      this.detailData = data;
      this.tabId = data.id;
      this.getInfo(data.id);
      this.getGroup(data.id);
    },

    deleteMsg(index, row) {
      this.$confirm("是否删除该用户?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axiospost(
          "operation/empApi/deleteEmp",
          obj2urlsp({
            id: row.id,
          })
        )
          .then(res => {
            this.$message.success("删除成功");
            this.getInfo(this.detailData.id);
          })
          .catch(error => {
            this.$message.error("删除失败");
          });
      });
    },
    addnew() {},
  },
  created() {
    this.getTree();
  },
};
</script>
<style scope lang="less">
.box {
  height: 100%;
}
.companycontent {
  height: calc(100% - 80px);
}
.showMore {
  width: 100%;
  display: flex;
  height: calc(100% - 80px);
}
.breadcrumb {
  margin-top: 0;
}
.interval {
  height: 10px;
  background-color: #edf0f5;
}
.companyInfo {
  height: 100%;
  background-color: #0e0e18;
  display: flex;
  .showTree {
    width: 260px;
    height: 100%;
    overflow: hidden;
    background-color: #181c2e;
    margin-right: 20px;
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node__content:hover,
    .el-tree > .el-tree-node > .el-tree-node__content,
    .is-current {
      background: transparent;
    }

    .el-tree-node:focus > .el-tree-node__content .el-tree-node__label,
    .el-tree-node__content:hover .el-tree-node__label,
    .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__label,
    .is-current > .el-tree-node__content .el-tree-node__label {
      background: #212740;
      transition: all 0.5s;
    }
    .el-tree {
      height: 100%;
      color: #b4b4b4;
      background: rgba(0, 0, 0, 0.2);
      overflow: auto;
      > .el-tree-node > .el-tree-node__content {
        height: 40px;
        width: 260px;
        background-color: #212740;
        margin: 0;
      }
      > .el-tree-node > .el-tree-node__content .custom-tree-node {
        height: 40px;
        line-height: 40px;
      }
      .el-tree-node__content {
        height: 34px;
        margin: 2px 0;
        display: block;
        padding: 0;
      }
      > .el-tree-node > .el-tree-node__content > .el-tree-node__expand-icon {
        margin-left: 25px;
        margin-top: 9px;
      }
      .el-tree-node__expand-icon {
        margin-left: 25px;
        margin-top: 5px;
        font-size: 14px;
        float: left;
        padding: 5px;
      }
      .custom-tree-node {
        font-size: 14px;
        display: block;
        width: 100%;
        height: 34px;
        line-height: 34px;
        border-bottom: 1px solid #464958;
        color: #c3c3c3;
        display: block;
      }
    }
  }
  .formtab {
    overflow: auto;
    height: calc(100% - 92px);
    > div {
      overflow: auto;
    }
  }
  // form
  .formtab,
  .rootCss {
    .OrangeSmBtn {
      width: auto;
      padding: 0 10px;
    }
    .dialog-footer {
      text-align: right;
    }
    margin-bottom: 20px;
    .el-form-item {
      background: transparent;
      color: #cacaca;
      .el-form-item__label {
        color: #ccc;
      }
      .el-tree-node:focus > .el-tree-node__content,
      .el-tree-node__content:hover,
      .el-tree > .el-tree-node > .el-tree-node__content,
      .is-current {
        background: transparent;
      }

      .el-tree-node:focus > .el-tree-node__content .el-tree-node__label,
      .el-tree-node__content:hover .el-tree-node__label,
      .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__label,
      .is-current > .el-tree-node__content .el-tree-node__label {
        background: #212740;
        transition: all 0.5s;
      }
      .el-tree {
        background: transparent;
        color: #cacaca;
        border: 1px solid #3d4963;
      }
      .el-tree:hover {
        border: 1px solid #409eff;
      }
      .el-input {
        .el-input__inner {
          background: transparent;
          color: #cacaca;
          border: 1px solid #3d4963;
        }
      }
    }
  }
  .treeDetail {
    width: calc(100% - 270px);
    overflow: hidden;
    position: relative;
    height: 100%;
    background-color: #181c2e;
    .el-tree {
      max-height: 360px;
      min-height: 30px;
      overflow: auto;
      padding: 5px 0 15px 0;
    }
  }
}
.companyIcon {
  height: 52px;
  line-height: 52px;
  margin-bottom: 23px;
  position: relative;
  border-top: 1px solid #2d374d;
  border-bottom: 1px solid rgba(53, 135, 199, 0.5);
  .lt {
    position: absolute;
    left: 0;
    width: 18px;
    height: 1px;
    background: #35b9f7;
    z-index: 3;
  }
  .rt {
    position: absolute;
    right: 0;
    width: 18px;
    height: 1px;
    background: #35b9f7;
    z-index: 3;
  }
  .btns{
    float: right;
  }
   .ptabs {
    display: inline-block;
    background: #253253;
    color: #fff;
    width: 115px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    .iconcheck {
      color: #35b9f7;
    }
    .border {
      background: linear-gradient(to right, #35bfff, #8553e7);
      width: inherit;
      height: 2px;
      position: absolute;
      bottom: -1px;
      left: 0;
    }
  }
}
.breadcrumb {
  margin-top: 0;
}
.interval {
  height: 10px;
  background-color: #edf0f5;
}
.treeSelect {
  color: #35b9f7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/basic/personnel/index.vue